import { render } from "./term-and-condition.vue?vue&type=template&id=bb378dbc&scoped=true"
import script from "./term-and-condition.vue?vue&type=script&lang=js"
export * from "./term-and-condition.vue?vue&type=script&lang=js"

import "./term-and-condition.vue?vue&type=style&index=0&id=bb378dbc&lang=css"
import "./term-and-condition.vue?vue&type=style&index=1&id=bb378dbc&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb378dbc"]])

export default __exports__